module.exports = __webpack_public_path__ + "static/media/icon.62953b74.png";